<template>
  <div class="work-collection-wrapper" :class="contributeStatus ? 'padding-bottom' : ''" ref="workCollection">
    <UserInfo :userInfo="userInfo" />
    <template v-if="showNoWorkData">
      <NoWorksData v-show="showNoWorkData" noDataText="暂无数据" />
    </template>
    <template v-else>
      <WorkList :worksList="worksList" @resfresPraise="handleRefreshPrasie" />
      <BottomLoading :showNoMore="noMoreWorkList" />
    </template>
    <div class="btn-wrapper">
      <BtnContribute v-if="contributeStatus" />
    </div>
    <!-- <button class="ui-btn" @click="handleShareMyCollections" v-if="systemInfo.isNfPlus">
      分享作品集
    </button> -->
  </div>
</template>

<script>
import WorkList from "@/components/WorkList/index"
import BottomLoading from "@/components/BottomLoading"
import UserInfo from "./components/UserInfo/index"
import NoWorksData from "@/components/NoWorksData"
import setDocumentTitle from "@/utils/setDocumentTitle"
import resolveUserUnit from "@/utils/resolveUserUnit"
import { mapActions, mapGetters, mapMutations } from "vuex"
import { buryingPoint_collection } from "@/server/buryingPoint"
import getUserInfo from "@/mixins/getUserInfo"
import BtnContribute from "./components/BtnContribute"

export default {
  name: "workCollection",
  data() {
    return {
      worksListSearchOptions: {
        page: 0,
        size: 10
      }
    }
  },
  mounted() {
    this.initScrollEvent()
  },
  mixins: [getUserInfo],
  methods: {
    ...mapMutations({
      showLoading: "loading/showLoading",
      hideLoading: "loading/hideLoading",
      saveScrollTop: "workCollection/saveScrollTop",
      getWorkCollectionUserIdActivityId: "workCollection/getWorkCollectionUserIdActivityId",
      setShareInfo: "activityInfo/setShareInfo",
      reviseWorkItem: "workCollection/reviseWorkItem"
    }),
    ...mapActions({
      getWorksList: "workCollection/getWorksList",
      getUserInfo: "workCollection/getUserInfo",
      getActivityInfo: "activityInfo/getActivityInfo",
      initWxShare: "activityInfo/initWxShare"
    }),
    initScrollEvent() {
      this.$refs.workCollection.onscroll = e => {
        if (this.scrollTimer) {
          window.clearTimeout(this.scrollTimer)
          this.scrollTimer = null
        }
        this.scrollTimer = window.setTimeout(() => {
          this.uploadMore(e)
        }, 17)
      }
    },
    uploadMore(scrollEvent) {
      const target = scrollEvent.target
      const scrollTop = target.scrollTop
      const homeDom = this.$refs.workCollection
      const homeScrollHeight = homeDom.scrollHeight
      const homeOffsetHeight = homeDom.offsetHeight
      const isToBottom = homeOffsetHeight + scrollTop + 10 > homeScrollHeight
      isToBottom && this.handleLoadMore()
    },
    handleLoadMore() {
      // @TODO 判断是否没有跟多数据或者正在加载中，等接口一起判断
      if (!this.loadingWork && !this.noMoreWorkList) {
        this.worksListSearchOptions.page++
        this._getWorksList()
      }
    },
    async _getWorksList(showLoading = false) {
      const finalFunc = () => {
        this.loadingWork = false
      }
      const params = {
        params: this.worksListSearchOptions,
        showLoading,
        finalFunc
      }
      this.loadingWork = true
      await this.getWorksList(params)
    },
    initShare() {
      this.oldShareInfo = this.shareInfo
      const shareInfo = {
        title: `${this.userInfo.userName}的作品集`,
        desc: this.authorInfo,
        link: `${window.location.origin}${window.location.pathname}?id=${this.activityId}&route=workCollection&userId=${this.userInfo.userId}`,
        imgUrl: this.userInfo.headImg || "https://static.nfapp.southcn.com/app/nanfang_logo.png"
      }
      const nfPlusShareInfo = {
        shareTitle: shareInfo.title,
        shareIcon: shareInfo.imgUrl,
        shareDesc: shareInfo.desc,
        shareUrl: shareInfo.link
      }
      this.setShareInfo(shareInfo)
      this.initWxShare()
      window.nfplusJsbridge.setShareInfo(nfPlusShareInfo)
      setDocumentTitle(shareInfo.title)
    },
    resetShare() {
      this.setShareInfo(this.oldShareInfo)
      this.initWxShare()
      const nfPlusShareInfo = {
        shareTitle: this.shareInfo.title,
        shareIcon: this.shareInfo.imgUrl,
        shareDesc: this.shareInfo.desc,
        shareUrl: this.shareInfo.link
      }
      window.nfplusJsbridge.setShareInfo(nfPlusShareInfo)
      setDocumentTitle(this.shareInfo.title)
    },
    async init() {
      this.getWorkCollectionUserIdActivityId()
      this._getWorksList()
      await this.getUserInfo()
      await this.getActivityInfo({ notInitShare: true })
      this.initShare()
    },
    handleShareMyCollections() {
      const nfPlusShareInfo = {
        title: this.shareInfo.title,
        icon: "https://static.nfapp.southcn.com/app/nanfang_logo.png",
        content: this.shareInfo.desc,
        url: this.shareInfo.link
      }
      window.nfplusJsbridge.share(nfPlusShareInfo)
    },
    _saveScrollTop() {
      const home = this.$refs.homeWrapper
      let scrollTop = 0
      home && (scrollTop = home.scrollTop)
      this.saveScrollTop(scrollTop)
    },
    setScrollTop() {
      const home = this.$refs.homeWrapper
      if (home && this.scrollTop) {
        home.scrollTop = this.scrollTop
      }
    },
    handleRefreshPrasie(praiseOptions) {
      this.reviseWorkItem(praiseOptions)
    }
  },
  components: {
    WorkList,
    BottomLoading,
    UserInfo,
    NoWorksData,
    BtnContribute
  },
  computed: {
    ...mapGetters({
      noMoreWorkList: "workCollection/noMoreWorkList",
      worksList: "workCollection/worksList",
      userInfo: "workCollection/userInfo",
      shareInfo: "activityInfo/shareInfo",
      singleShareDesc: "activityInfo/singleShareDesc",
      activityId: "activityInfo/activityId",
      scrollTop: "workCollection/scrollTop",
      systemInfo: "systemInfo",
      contributeStatus: "activityInfo/contributeStatus"
    }),
    showNoWorkData() {
      return this.worksList.length < 1
    },
    authorInfo() {
      const singleShareDesc = this.singleShareDesc || ""
      let authorInfoArr = [
        this.userInfo.userName || "",
        `${this.userUnit}${this.userInfo.grade ? this.userInfo.grade.gradeName || "" : ""}`
      ]
      authorInfoArr = authorInfoArr.filter(authorItem => authorItem !== "")
      let authorInfoStr = authorInfoArr.join(" ")
      if (singleShareDesc !== "" && authorInfoArr.length > 1) {
        authorInfoStr = `（${authorInfoStr}）`
      }
      const authorInfoDescArr = [singleShareDesc, authorInfoStr].filter(item => item !== "")
      return authorInfoDescArr.join(" ")
    },
    userUnit() {
      return resolveUserUnit(this.userInfo)
    }
  },
  created() {
    this.init()
    buryingPoint_collection()
  },
  activated() {
    this.initShareInfo()
    this.setScrollTop()
  },
  beforeRouteLeave(to, from, next) {
    this.resetShare()
    this._saveScrollTop()
    next()
  }
}
</script>

<style lang="scss" scoped>
.work-collection-wrapper {
  height: 100%;
  width: 100%;
  overflow: auto;
  &.padding-bottom {
    padding-bottom: 1.2rem;
  }
  .ui-btn {
    width: 3rem;
    height: 0.88rem;
    background: #f64e45;
    border-radius: 0.44rem;
    color: #ffffff;
    font-family: PingFangSC-Regular;
    font-size: 0.3rem;
    outline: none;
    border: none;
    line-height: 0.88rem;
    text-align: center;
    position: fixed;
    left: 50%;
    bottom: 0.4rem;
    transform: translate3d(-50%, 0, 0);
    &[disabled] {
      opacity: 0.5;
    }
    &:active {
      opacity: 0.7;
    }
  }
  .btn-wrapper {
    position: fixed;
    left: 50%;
    bottom: 0.4rem;
    transform: translate3d(-50%, 0, 0);
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
